import { del, get, post, put } from './request'

interface Policy {
    supplier: string;
    propertyId: string;
    property: {
        policies: object
    };
}


export const getPolicies = (supplier: string, propertyid: string) => get(`/property/policies?supplier=${supplier}&propertyid=${propertyid}`)

/*
    All the below APIs are for adding, updating and deleting  the invidual sub-categories. All of them will return the same response as the GET api response.
*/

export const saveOrUpdatePolicyGeneral = (policy: Policy) => post('/property/policies/general', policy)
export const saveOrUpdatePolicyCheckoutCharge = (policy: Policy) => post('/property/policies/checkoutcharge', policy)
export const saveOrUpdatePolicyCommission = (policy: Policy) => post('/property/policies/commission', policy)
export const savePolicyCancellation = (policy: Policy) => post('/property/policies/cancel', policy)
export const updatePolicyCancellation = (policy: Policy) => put('/property/policies/cancel', policy)

export const deletePolicyCancellation = (policy: Policy) => del('/property/policies/cancel', policy)
export const deletePolicyFees = (policy: Policy) => del('/property/policies/fee', policy)
export const updatePolicyFees = (policy: Policy) => put('/property/policies/fee', policy)
export const addPolicyFees = (policy: Policy) => post('/property/policies/fee', policy)

export const deleteOtherPolicy = (policy: Policy) => del('/property/policies/other', policy)
export const updateOtherPolicy = (policy: Policy) => put('/property/policies/other', policy)
export const addOtherPolicy = (policy: Policy) => post('/property/policies/other', policy)


export const savePolicyGuaranteePayment = (policy: Policy) => post('/property/policies/guarantee', policy)
export const putPolicyGuaranteePaymentDetails = (policy: Policy) => put('/property/policies/guarantee', policy)

export const postPolicyGuaranteePaymentAccPayment = (policy: Policy) => post('/property/policies/guaranteepolicy/acceptedpayment', policy)
export const putPolicyGuaranteePaymentAccPayment = (policy: Policy) => put('/property/policies/guaranteepolicy/acceptedpayment', policy)
export const postPolicyGuaranteePaymentAddress = (policy: Policy) => post('/property/policies/guaranteepolicy/paymentaddress', policy)
export const putPolicyGuaranteePaymentAddress = (policy: Policy) => put('/property/policies/guaranteepolicy/paymentaddress', policy)

export const delPolicyGuaranteePayment = (policy: Policy) => del('/property/policies/guarantee', policy)

export const deletePolicyPets = (policy: Policy) => del('/property/policies/pet', policy)
export const updatePolicyPets = (policy: Policy) => put('/property/policies/pet', policy)
export const addPolicyPets = (policy: Policy) => post('/property/policies/pet', policy)

export const savePolicyTax = (policy: Policy) => post('/property/policies/tax', policy)
export const putPolicyTax = (policy: Policy) => put('/property/policies/tax', policy)
export const delPolicyTax = (policy: Policy) => del('/property/policies/tax', policy)

